import React from 'react';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { Info, X } from 'lucide-react';

interface EstadoFilterProps {
  estadoFilter: string;
  onEstadoFilterChange: (filter: string) => void;
  onClearFilter: () => void;
}

const EstadoFilter: React.FC<EstadoFilterProps> = ({
  estadoFilter,
  onEstadoFilterChange,
  onClearFilter,
}) => {
  return (
    <div className="flex flex-col gap-3 p-4 bg-gray-50 rounded-lg border">
      <div className="flex items-center gap-2">
        <Info className="h-4 w-4" />
        <span className="text-sm font-medium">Filtro por estado</span>
      </div>

      <div className="flex flex-col sm:flex-row gap-3">
        <div className="flex flex-col gap-2">
          <label className="text-xs font-medium text-gray-600">Estado del trámite</label>
          <Select value={estadoFilter || 'todos'} onValueChange={onEstadoFilterChange}>
            <SelectTrigger className="w-full sm:w-48">
              <SelectValue placeholder="Seleccionar estado" />
            </SelectTrigger>
            <SelectContent>
              <SelectItem value="todos">Todos</SelectItem>
              <SelectItem value="finalizado">Finalizado</SelectItem>
              <SelectItem value="En proceso">En Proceso</SelectItem>
            </SelectContent>
          </Select>
        </div>

        <div className="flex flex-col gap-2">
          <label className="text-xs font-medium text-gray-600 invisible">Acciones</label>
          <div className="flex gap-2">
            <Button
              onClick={onClearFilter}
              variant="outline"
              size="sm"
              className="px-3"
              disabled={!estadoFilter || estadoFilter === 'todos'}
            >
              <X className="h-4 w-4" />
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EstadoFilter;
